import { IModalScope } from "angular-ui-bootstrap";
import { IDataSourceBlueprint } from "@gtmhub/datasources/models/models";
import { DataSourceService } from "@gtmhub/datasources/services/dataSourceService";
import { UIErrorHandlingService } from "@gtmhub/error-handling";
import { IConnectionData } from "../../../models/models";
import { InsightSelectorAction } from "../models";

export interface IBrowseConnectionsScope extends IModalScope {
  indicators: {
    getting: boolean;
  };
  connections: IDataSourceBlueprint[];
  selectConnection(connection: IDataSourceBlueprint): void;
}

export class BrowseConnectionsCtrl {
  public static $inject = ["$scope", "DataSourceService", "UIErrorHandlingService"];

  constructor(private $scope: IBrowseConnectionsScope, private datasourceService: DataSourceService, private uiErrorHandlingService: UIErrorHandlingService) {
    this.$scope.indicators = {
      getting: true,
    };
    this.$scope.selectConnection = this.selectConnection;

    this.init();
  }

  private init = () => {
    const fields = "name,title,logoUrl";

    return this.datasourceService.getBlueprintsWithConnection(fields, true).then(
      (connections: IDataSourceBlueprint[]) => {
        this.$scope.indicators.getting = false;
        this.$scope.connections = connections.sort((a, b) => a.name.localeCompare(b.name));
      },
      (error) => this.uiErrorHandlingService.handleIndicator(error, { indicator: "getting", inline: true })
    );
  };

  private selectConnection = (connection: IDataSourceBlueprint) => {
    const params: { action: InsightSelectorAction; connectionData: IConnectionData } = {
      action: "browseInsights",
      connectionData: {
        id: connection.id,
        name: connection.name,
        title: connection.title,
        logoUrl: connection.logoUrl,
      },
    };

    this.$scope.$close(params);
  };
}
